import * as type from './constant';

export const getCostUser = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getCostUserSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getCostUserError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addCostUser = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addCostUserSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateCostUser = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateCostUserSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteCostUser = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteCostUserSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationCostUserError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
